// extracted by mini-css-extract-plugin
module.exports = {"microsoftAdsCard":"kD-z"};